/**
 * Cancellation flow UI strings
 */

export const OFFER_MODAL_STRINGS = {
    FREE_MONTH: {
        TITLE: 'Need more time?',
        SUBTITLE: 'Get a free month on us.',
        DESCRIPTION:
            'Get an extra month free, to bring in more leads, test new offers, and get paid for what you know.',
        ACCEPT_LABEL: 'Claim a free month',
        DECLINE_LABEL: 'No thanks, cancel my subscription',
        IMAGE_ALT: 'Free Month Offer',
    },
    TWO_MONTHS_DISCOUNT: {
        TITLE: 'Get 50% off for the next 2 months️',
        SUBTITLE: "Don't miss out on the tools that help you win.🙋‍",
        DESCRIPTION: 'Use this time to double-down on your Creator biz and make the most of it!',
        ACCEPT_LABEL: 'Get 50% off',
        DECLINE_LABEL: "I'm good",
    },
} as const;

export const OFFER_ACCEPTED_MODAL_STRINGS = {
    FREE_MONTH: {
        TITLE: 'Your free month is activated 🚀',
        SUBTITLE: 'Check your email',
        DESCRIPTION: 'for tips on how to make the most of the next 30 days, or reach out to us at friends@stanwith.me',
        IMAGE_ALT: 'Free Month Activated',
    },
    TWO_MONTHS_DISCOUNT: {
        TITLE: 'Your discount is activated 🚀',
        SUBTITLE: 'Check your email for details',
        DESCRIPTION:
            'for tips on how to make the most of your discount period, or reach out to us at friends@stanwith.me',
    },
    BUTTON_LABEL: 'Back to My Store',
} as const;

export const GOODBYE_MODAL_STRINGS = {
    TITLE: 'Your subscription is cancelled',
    DESCRIPTION_PREFIX: 'Your account will remain active until the end of this period on',
    DESCRIPTION_SUFFIX: '. Have any questions? Reach out to',
    SUPPORT_EMAIL: 'friends@stanwith.me',
    SURVEY: {
        TITLE: 'How was your\ncancellation experience?',
        THANK_YOU: 'Thanks for letting us know!',
    },
    BUTTON_LABEL: 'Close',
} as const;
